import { render } from "./ProfileEdit.vue?vue&type=template&id=7db9912a"
import script from "./ProfileEdit.vue?vue&type=script&lang=js"
export * from "./ProfileEdit.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3444732531/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__